module.exports = "latest-registrations"